export class HistoryMergerInputParams {
    constructor() {
        this.ShowExtendedSession = true;
    }
    get IsFilterNotAllowedPeriods() {
        const currentAccount = this.Account;
        if (isNullOrUndefined(currentAccount))
            return true;
        return !currentAccount.isAllowOTHTrading(this.Instrument);
    }
}
